import { Button } from "@material-ui/core"
import React, { useCallback, useEffect, useRef, useState } from "react"

type ReenviarcodigoProps = {
    onReenviar: () => Promise<any> | any
    tempo?: number
}

export const Reenviarcodigo = ({ onReenviar, tempo = 30 }: ReenviarcodigoProps) => {
    const [disabled, setDisabled] = useState(false)
    const [segundos, setSegundos] = useState<number>(0)
    const timerRef = useRef<any>(null)

    const iniciarContador = useCallback((inicio: number) => {
        setSegundos(inicio)
        if (timerRef.current) {
            clearInterval(timerRef.current)
            timerRef.current = null
        }
        timerRef.current = setInterval(() => {
            setSegundos((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current)
                    timerRef.current = null
                    setDisabled(false)
                    return 0
                }
                return prev - 1
            })
        }, 1000)
    }, [])

    const handleClick = useCallback(async () => {
        if (disabled) return
        setDisabled(true)
        try {
            await onReenviar()
            iniciarContador(tempo)
        } catch {
            setDisabled(false)
        }
    }, [disabled, iniciarContador, onReenviar, tempo])

    useEffect(() => {
        setDisabled(true)
        iniciarContador(tempo)
    }, [iniciarContador, tempo])

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current)
                timerRef.current = null
            }
        }
    }, [])

    return (
        <Button variant="text" color="primary" size="large" disabled={disabled} onClick={handleClick}>
            {disabled ? `Reenviar em ${segundos}s` : "Reenviar Código"}
        </Button>
    )
}
